// extracted by mini-css-extract-plugin
module.exports = {"locationTitle":"IndexSystemList_locationTitle__1x_8z","cardStation":"IndexSystemList_cardStation__2rRcV"};